import { Carousel } from "antd";
import React from "react";
import { FormLabel } from "react-bootstrap";
import Image from "react-bootstrap/Image";
import { labels } from "../../../../localization/labels";
import { constants } from "../../../../utils/Constants";
import PathUtil from "../../../../utils/PathUtil";
import SecurityUtils from "../../../../utils/SecurityUtils";
import { paths } from "../../../paths";

const renderItems = (recommendedKnowledge, openKnowledge) => {
  return recommendedKnowledge.map(knowledge => (
    <div className="recommended-item-container">
      <FormLabel
        className="Title selectable"
        onClick={event => {
          event.preventDefault();
          event.stopPropagation();
          openKnowledge(knowledge);
        }}
      >
        {knowledge?.name}
      </FormLabel>
      <p>
        <FormLabel>{knowledge?.description}</FormLabel>
      </p>
    </div>
  ));
};

const RecommendedKnowledge = ({
  recommendedKnowledge,
  infoWidgetImage,
  changePath
}) => {
  const openKnowledge = knowledge => {
    if (
      SecurityUtils.partyHasPermissionOnEntity(
        knowledge,
        constants.OPERATION_READ
      )
    ) {
      const itemPath = PathUtil.itemPath(paths.KNOWLEDGE_ITEM, knowledge.id);
      changePath(itemPath, knowledge.name);
    } else return undefined;
  };

  return (
    <div className="containerShadow">
      <div className="infoWidget animationPulse">
        <div className="bamBarChart">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <Image className="infoWidgetImage" src={infoWidgetImage}></Image>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-12">
            <FormLabel className="infoWidgetLabel">
              {labels.recommended}
            </FormLabel>
          </div>
          <div className="responsiveContainer">
            <Carousel autoplay className="recommended-carousel">
              {renderItems(recommendedKnowledge, openKnowledge)}
            </Carousel>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecommendedKnowledge;
